import styled, { keyframes } from 'styled-components';

import { SpinnerIcon as BaseIcon } from '../../icons';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(1px);
`;

export const SpinnerIcon = styled(BaseIcon)<{ $size?: number }>`
  flex: 0 0 auto;
  width: ${({ $size }) => $size || 16}px;
  height: ${({ $size }) => $size || 16}px;
  animation: ${spin} 4000ms linear infinite;
`;
